<template>
  <div v-if="currentUser.role.is_authorizer">
    <div v-if="approveStatus !== 2"></div>

    <div v-else>
      <!-- TODO: change method -->
      <AppRejectBtn color="blue" @click="submitReject(currentPoliticalAction.report.id,4)" docType="result" />
      <AppApproveBtn color="blue" @click="approveRequest(currentPoliticalAction.report.id,4)" docType="result" />
    </div>
  </div>
  <div v-else>
    <div
      v-if="approveStatus == 2"
      class="flex items-center"
    >
      <AppWaitingBtn color="blue" :approveStatus="approveStatus" />
      <AppCancelBtn color="blue" @click="cancelRequest(currentPoliticalAction.report.id,4)"/>
    </div>
    <div v-else-if="approveStatus == 4"
      class="flex items-center"
    >
      <AppApprovedBtn color="blue"  />
      <AppCancelBtn color="blue" disabled/>
    </div>
    <div v-else>
      <div v-if="activityDialog.isPreviewResult" class="items-center">
        <AppApplyBtn
          color="blue"
          @click="submitActivity(currentPoliticalAction.id,'report-apply')"
          form="resultForm"
          type="submit"
        />
        <button
          class="box-border h-10 bg-white border-4 border-blue disabled:opacity-50 disabled:bg-black"
          style="border-radius: 20px; width: 180px;"
          @click="showPreviewResult(false)"
        >
          <div class="flex flex-row items-center justify-center">
            <edit-circle-icn
              width="20"
              height="20"
              class="mr-1"
            ></edit-circle-icn>
            <span class="text-blue text-lg font-bold leading-tight">
              作成に戻る
            </span>
          </div>
        </button>
      </div>
      <div v-else>
        <AppShowPreviewBtn
          color="blue"
          @click="showPreviewResult(true)"
          v-if="!activityDialog.isPreviewResult"
          :disabled="!activityDialog.isPreviewResultEnabled"
        />
        <AppTempSaveBtn @click="submitActivity(currentPoliticalAction.id,'report')" color="blue" />
      </div>
    </div>
  </div>
</template>

<script>
import { usePoliticalActionDialog } from '@/services/politicalAction/usePoliticalActionDialog'
import AppApplyBtn from '@/components/ui/AppApplyBtn'
import AppTempSaveBtn from '@/components/ui/AppTempSaveBtn'
import AppRejectBtn from '@/components/ui/AppRejectBtn'
import AppApproveBtn from '@/components/ui/AppApproveBtn'
import AppShowPreviewBtn from '@/components/ui/AppShowPreviewBtn'
import AppCancelBtn from '@/components/ui/AppCancelBtn'
import AppWaitingBtn from '@/components/ui/AppWaitingBtn'
import AppApprovedBtn from '@/components/ui/AppApprovedBtn'
import { usePoliticalActions } from '@/services/politicalAction/usePoliticalActions'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useResultForm } from '@/services/politicalAction/useResultForm'
import { useResultReject } from '@/services/politicalAction/useResultReject'

import EditCircleIcn from '@/assets/icons/edit-circle.svg?inline'

export default {
  name: 'ActivitiesDialogResultFooter',

  components: {
    AppApplyBtn,
    EditCircleIcn,
    AppTempSaveBtn,
    AppRejectBtn,
    AppApproveBtn,
    AppShowPreviewBtn,
    AppCancelBtn,
    AppWaitingBtn,
    AppApprovedBtn,
  },

  props: {
    approveStatus: Number,
  },

  setup() {
    const { currentUser } = useCurrentUser()
    return {
      currentUser,
      ...usePoliticalActionDialog(),
      ...usePoliticalActions(),
      ...useResultForm(),
      ...useResultReject()
    }
  },
}
</script>
<style lang=""></style>
